import React, {useEffect, useRef, useState} from "react"
import {ClipLoader, RiseLoader} from "react-spinners";
import {Controller, useForm} from "react-hook-form"
import {useStateValue} from "../../../states/StateProvider"
import moment from 'moment';
import DatePicker, {registerLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import de from "date-fns/locale/de";
import Api from "../../../Api/api";
import Options from "./fields/options";
import {toast} from "react-toastify";
import {GoCalendar} from "react-icons/go";
import {AES, enc} from "crypto-js";
import BeratertageModal from "../../../components/modal/BeratertageModal";
import EditIcon from "../../../assets/dateinachweise.png";
import EditIconNoDocuments from "../../../assets/no-dateinachweise.png";
import UpsellingIcon from "../../../assets/upselling.png";
import UpsellingIconNoUpselling from "../../../assets/no-upselling.png";
import CompanyUpsellingBadge from "./CompanyUpsellingBadge";
import UpdateUpselling from "../../../components/modal/updateUpselling";
import Modal from "../../../hooks/modal";
import useModal from "../../../hooks/useModal";
import Services from "../../reporting/partial/Services";
import DienstleistungenModal from "../../../components/modal/DienstleistungenModal";

registerLocale("de", de);

const SubSteps = ({data, loading, next, lastDoneIndex, grid, options, firma, title, lastIndex, portal, milestone, hasUpselling, dataUpselling}) => {

    const {toggleUpsellingModal} = useModal();
    const [Loading, setLoading] = useState(false)
    const [erfBeratTage, setErfBeratTage] = useState(0)
    const initialState = [];
    const ref = useRef()
    const datePickerRef = useRef(null);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState({});
    const [{currentMilestone, subStepSaved, secretKey, beratertageModalOpen, upsellingModal}, dispatch] = useStateValue();
    const {
        register, reset, getValues, setValue, handleSubmit, formState, formState: {errors, touchedFields}, control
    } = useForm({mode: "onChange"});
    const {isValid} = formState;
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const role = user.role
    // const [update, setUpdated] = useState((localStorage.data && user.ID===JSON.parse(localStorage.data)[0]?.user )? JSON.parse(localStorage.data): [])
    const [update, setUpdated] = useState([])
    const [{noteSent}] = useStateValue();
    const [beraterDefaults, setBeraterDefaults] = useState(null);
    const [upsellingOptions, setUpsellingOptions] = useState(false);
    const [edit, setEdit] = useState(false)
    const [editInfo, setEditInfo] = useState('')
    const [editInfoFull, setEditInfoFull] = useState('')
    const [editID, setEditID] = useState(1)
    const [dienstleistungenModalOpen, setDienstleistungenModalOpen] = useState(false)

    useEffect(() => {
        let key = 'id';
        const unique = [...new Map(update?.map(item => [item[key], item])).values()];
        const handleBeforeUnload = (event) => {
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [update, currentMilestone]);

    useEffect(() => {
        const handleDocumentClick = (event) => {
            if (datePickerRef.current && !datePickerRef.current?.contains(event.target)) {
                setIsDatePickerOpen(false);
            }
        };
        const handleScroll = () => {
            setIsDatePickerOpen(false);
        };
        document.addEventListener('click', handleDocumentClick);
        window.addEventListener('scroll', handleScroll);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (data.length > 0) {
            data?.map(async (d, index) => {
                // Find grid item by matching stepID instead of using array index
                const gridItem = grid.find(g => g.stepID === d.substepID);

                if (gridItem?.fieldValue) {
                    if (d.fieldType === 'date') {
                        let newDate = moment(gridItem.fieldValue).toDate()
                        const dateFormat = 'DD-MM-YYYY';
                        const toDateFormat = moment(new Date(newDate)).format(dateFormat);
                        let valid = moment(toDateFormat, dateFormat, true).isValid()
                        if (valid) {
                            setValue(`${d.stepName}`, newDate)
                        } else {
                            setValue(`${d.stepName}`, moment(new Date()).toDate())
                        }
                    }
                    if (d.fieldType === 'datero') {
                        const raw = gridItem.fieldValue;
                        const date = moment(raw);
                        const formatted = date.isValid() ? date.format('DD.MM.YYYY') : '';
                        const valueToSet = formatted === '01.01.1970' ? '' : formatted;
                        setValue(`${d.substepID}`, valueToSet);
                    }
                    if (d.fieldType === 'option') {
                        if (gridItem.fieldValue !== null) {
                            let filter = options.map(o => o.filter(oo => Number(oo.substepID) === Number(d.substepID)))
                            let filteredOption = filter.filter(f => f.length > 0)[0]
                            if (filteredOption) {
                                if (gridItem.fieldValue.length > 1) {
                                    await setValue(`${d.stepName}`, gridItem.fieldValue)
                                } else {
                                    if (gridItem.fieldValue === '0') {
                                        await setValue(`${d.stepName}`, 'Nein')
                                    } else if (gridItem.fieldValue === '1') {
                                        await setValue(`${d.stepName}`, 'Ja')
                                    } else {
                                        await setValue(`${d.stepName}`, null)
                                    }
                                }
                            }
                        } else {
                            await setValue(`${d.stepName}`, null)
                        }
                    }

                    if (d.fieldType === 'text' || d.fieldType === 'r_only') {
                        setValue(`${d.substepID}`, `${gridItem.fieldValue}`)
                    }

                    if (parseInt(d.substepID) === 3 && d.fieldType !== 'datero') {
                        setValue(`${d.substepID}`, formatCurrency(gridItem.fieldValue));
                    }

                    if (parseInt(d.substepID) === 5) {
                        setValue(`${d.substepID}`, formatCurrencyDecimal(gridItem.fieldValue));
                    }

                    if (parseInt(d.substepID) === 6) {
                        setValue(`${d.substepID}`, formatPercentage(gridItem.fieldValue));
                    }

                    if (parseInt(d.substepID) === 11) {
                        setValue(`${d.substepID}`, formatDecimal(gridItem.fieldValue));
                    }
                }
            })
        }

    }, [data, grid, setValue, next, options]);

    // Fetch consultant calculation data for erfBeratTage
    useEffect(() => {
        const fetchConsultantCalcData = async () => {
            if ((milestone === '8' && portal === 'dgg') || (milestone === '11' && portal === 'ruv')) {
                try {
                    const res = await Api().get(`/sp_getDataConsultantCalc/${portal}/${firma}`);
                    const entry = res?.data?.[0];
                    if (entry) {
                        const parseGermanNumber = (val) => {
                            if (val === null || val === undefined) return 0;
                            if (typeof val === "number") return val;
                            let s = String(val).trim();

                            // Special handling for AnzahlBeratungstage: if it's like "10.000", treat as 10
                            if (s.endsWith('.000') && s.split('.').length === 2) {
                                return parseFloat(s.split('.')[0]);
                            }

                            s = s.replace(/\./g, "").replace(",", ".");
                            const result = parseFloat(s);
                            return isNaN(result) ? 0 : result;
                        };

                        // Calculate erfBeratTage using the same formula as modal
                        const MA = parseInt(entry.MA ?? 0);
                        let BeteiligungsQuote = parseFloat(entry.BeteiligungsQuote ?? 0);
                        // Convert percentage to fraction (70 -> 0.70)
                        if (BeteiligungsQuote > 1) {
                            BeteiligungsQuote = BeteiligungsQuote / 100;
                        }
                        const BeratungenProMA = parseGermanNumber(entry.BeratungenProMA ?? 0);
                        const BeratungenProTag = Math.max(1, parseGermanNumber(entry.BeratungenProTag ?? 0));
                        const EingesetztBerater = Math.max(1, parseGermanNumber(entry.AnzahlBerater ?? 0));

                        const maLtQuote = Math.ceil(MA * BeteiligungsQuote);
                        const calculated = Math.ceil(maLtQuote * BeratungenProMA / BeratungenProTag / EingesetztBerater);

                        setErfBeratTage(calculated);
                    }
                } catch (error) {
                    console.error('Error fetching consultant calc data:', error);
                    setErfBeratTage(0);
                }
            }
        };

        fetchConsultantCalcData();
    }, [portal, firma, milestone]);

    // Refetch consultant calculation data when modal closes (after save)
    useEffect(() => {
        const fetchConsultantCalcData = async () => {
            if ((milestone === '8' && portal === 'dgg') || (milestone === '11' && portal === 'ruv')) {
                try {
                    const res = await Api().get(`/sp_getDataConsultantCalc/${portal}/${firma}`);
                    const entry = res?.data?.[0];
                    if (entry) {
                        const parseGermanNumber = (val) => {
                            if (val === null || val === undefined) return 0;
                            if (typeof val === "number") return val;
                            let s = String(val).trim();

                            // Special handling for AnzahlBeratungstage: if it's like "10.000", treat as 10
                            if (s.endsWith('.000') && s.split('.').length === 2) {
                                return parseFloat(s.split('.')[0]);
                            }

                            s = s.replace(/\./g, "").replace(",", ".");
                            const result = parseFloat(s);
                            return isNaN(result) ? 0 : result;
                        };

                        // Calculate erfBeratTage using the same formula as modal
                        const MA = parseInt(entry.MA ?? 0);
                        let BeteiligungsQuote = parseFloat(entry.BeteiligungsQuote ?? 0);
                        // Convert percentage to fraction (70 -> 0.70)
                        if (BeteiligungsQuote > 1) {
                            BeteiligungsQuote = BeteiligungsQuote / 100;
                        }
                        const BeratungenProMA = parseGermanNumber(entry.BeratungenProMA ?? 0);
                        const BeratungenProTag = Math.max(1, parseGermanNumber(entry.BeratungenProTag ?? 0));
                        const EingesetztBerater = Math.max(1, parseGermanNumber(entry.AnzahlBerater ?? 0));

                        const maLtQuote = Math.ceil(MA * BeteiligungsQuote);
                        const calculated = Math.ceil(maLtQuote * BeratungenProMA / BeratungenProTag / EingesetztBerater);

                        setErfBeratTage(calculated);
                    }
                } catch (error) {
                    console.error('Error fetching consultant calc data:', error);
                    setErfBeratTage(0);
                }
            }
        };

        // Refetch data when modal closes (beratertageModalOpen changes from true to false)
        if (!beratertageModalOpen) {
            fetchConsultantCalcData();
        }
    }, [beratertageModalOpen, portal, firma, milestone]);

    const formatCurrencyDecimal = (value) => {
        if (!value || isNaN(value)) return "";
        return new Intl.NumberFormat("de-DE", {
            style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(parseFloat(value));
    };

    const formatCurrency = (value) => {
        if (!value || isNaN(value)) return "0€";

        // Check if value has decimals
        const hasDecimals = value % 1 !== 0;

        // Format the number using Intl.NumberFormat
        let formatted = new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: hasDecimals ? 2 : 0
        }).format(value);

        // Remove any non-breaking spaces (sometimes added by Intl.NumberFormat)
        return formatted.replace(/\s/g, "");
    };

    const formatPercentage = (value) => {
        if (!value || isNaN(value)) return "";
        return new Intl.NumberFormat("de-DE", {
            style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1
        }).format(value); // Divide by 100 to correctly format as percentage
    };

    const formatDecimal = (value) => {
        if (!value || isNaN(value)) return "";
        return new Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 1, maximumFractionDigits: 1
        }).format(parseFloat(value));
    };

    const sanitizeCurrencyInput = (input) => {
        if (!input) return 0;

        // Remove non-numeric characters except "." and ","
        let sanitized = input.replace(/[^0-9,\.]/g, "");

        // If there are multiple dots (thousand separators), remove them
        if (sanitized.includes(",")) {
            sanitized = sanitized.replace(/\./g, ""); // Remove thousand separators
            sanitized = sanitized.replace(",", "."); // Convert decimal separator
        }

        // Convert to a float number
        return parseFloat(sanitized) || 0;
    };


    const addObjectToArray = obj => {
        if (parseInt(obj.id) === 3 && obj.type !== 'date' && obj.type !== 'datero' && obj.type !== 'option') {
            obj.value = sanitizeCurrencyInput(obj.value);
        }

        if (obj.type === 'datero') {
            const parsed = moment.utc(obj.value, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
            obj.value = parsed.isValid() ? parsed.toISOString() : obj.value;
        }

        setUpdated(current => current && [...current, obj])
    };

    function convertLocalToUTCDate(date)
    {
        if (!date) {
            return date
        }
        date = new Date(date)
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
        return date
    }

    const onSubmit = async (Data) => {
        const key = 'id';
        const unique = [...new Map(update?.map(item => [item[key], item])).values()];

        if (unique.length > 0) {
            unique[0].portal = portal;

            setLoading(true);
            Api().post('/saveSteps', unique).then(async res => {
                localStorage.removeItem('data');
                dispatch({type: "SET_SUBSTEPSAVED", item: !subStepSaved});
                toast.success('Daten erfolgreich gespeichert');

                // MS11: Beratertage-Erweiterung planen
                if (
                    (milestone === '11' && portal === 'ruv')
                    || (milestone === '8' && portal === 'dgg')
                ) {
                    const beraterData = Data.Beratertage || {};
                    try {
                        await Api().post('/sp_putConsultantCalc', {
                            portal: portal,
                            fpId: firma,
                            ma: beraterData.MA,
                            betQuote: parseFloat(beraterData.BetQuote || 0) / 100, // Convert percentage to fraction
                            anzBeratungen: parseFloat(beraterData.EingesetztBerater || 0),
                            beratungenProTag: parseFloat(beraterData.BeratungenProTag || 0),
                            beratungenProMA: parseFloat(beraterData.BeratungProMA || 0),
                            anzahlBeratungstage: parseFloat(beraterData.AnzBeratungstage || 0)
                        });
                        toast.success('Beratertage erfolgreich gespeichert');
                    } catch (e) {
                        console.error(e);
                        toast.error('Fehler beim Speichern der Beratertage');
                    }
                }

                // Check if final step was changed and send note only if it was
                const finalStepMeta = data.find(step => String(step.isFinalStep) === '1');

                if (finalStepMeta) {
                    const idx = Number(finalStepMeta.substepID) - 1;
                    const prevRaw = grid?.[idx]?.fieldValue;

                    // Name of the current field differs for date vs datero
                    const currRaw =
                        finalStepMeta.fieldType === 'datero'
                            ? getValues(finalStepMeta.substepID)      // you registered with substepID
                            : getValues(finalStepMeta.stepName);      // Controller uses stepName

                    const prevEmpty = isEmptyFinalDate(prevRaw);
                    const currEmpty = isEmptyFinalDate(currRaw);

                    let shouldSend = false;
                    let body;

                    if (prevEmpty && currEmpty) {
                        // no change → don't send
                        shouldSend = false;
                    } else if (prevEmpty && !currEmpty) {
                        // added / newly set
                        const formattedDate = normalizeToMoment(currRaw)?.format('DD.MM.YYYY');
                        body = `${user.fullname} hat im Meilenstein "${title}" das Datum ${formattedDate} abgeschlossen.`;
                        shouldSend = true;
                    } else if (!prevEmpty && currEmpty) {
                        // cleared / deleted
                        body = `${user.fullname} hat im Meilenstein "${title}" das Datum gelöscht.`;
                        shouldSend = true;
                    } else {
                        // both non-empty → changed or same?
                        const prevM = normalizeToMoment(prevRaw);
                        const currM = normalizeToMoment(currRaw);
                        if (!prevM || !currM || !prevM.isSame(currM, 'day')) {
                            const formattedDate = currM ? currM.format('DD.MM.YYYY') : '';
                            body = `${user.fullname} hat im Meilenstein "${title}" das Datum ${formattedDate} abgeschlossen.`;
                            shouldSend = true;
                        }
                    }

                    if (shouldSend) {
                        const header = `Am ${moment().format('DD.MM.YYYY, HH:mm')}, ${user.fullname}\n`;
                        const formData = new FormData();
                        formData.append('note', header + body);
                        formData.append('userID', user.ID);
                        formData.append('firma', firma);
                        formData.append('portal', portal);
                        formData.append('art', 'AutoFP');

                        try {
                            await Api().post('/sendNote', formData);
                            dispatch({ type: 'SET_NOTE_SENT', item: !noteSent });
                        } catch (err) {
                            console.error(err);
                            toast.error('Fehler beim Speichern der automatischen Bemerkung');
                        }
                    }
                }
            }).catch(e => {
                setLoading(false);
                toast.error('Etwas ist schief gelaufen!');
            });
        } else {
            toast.warning('Sie haben nichts eingegeben');
        }
    };

    const isClearedFinalDate = (val) => {
        // cleared if null/empty OR sentinel "1900-01-01"
        if (val === null || val === undefined) return true;
        if (typeof val === 'string' && val.trim() === '') return true;

        // support both Date and string; compare on day-level
        const m = moment(val);
        if (!m.isValid()) return true; // treat invalid as cleared
        return m.isSame(moment('1900-01-01'), 'day');
    };

    const normalizeToMoment = (val) => {
        if (val === null || val === undefined) return null;
        if (typeof val === 'string' && val.trim() === '') return null;

        // accept ISO, YYYY-MM-DD, DD.MM.YYYY, DD-MM-YYYY
        const m = moment(val, ['YYYY-MM-DD', moment.ISO_8601, 'DD.MM.YYYY', 'DD-MM-YYYY'], true);
        return m.isValid() ? m.startOf('day') : null;
    };

    const isEmptyFinalDate = (val) => {
        const m = normalizeToMoment(val);
        if (!m) return true;
        // treat sentinels as empty
        return m.isSame(moment('1900-01-01'), 'day') || m.isSame(moment('1970-01-01'), 'day');
    };

    function setEditStates() {
        setDienstleistungenModalOpen(true);
    }

    const handleClick = async () => {
        setLoading(true)
        let data = new FormData()
        data.append('userId', user.fullname)
        data.append('portal', portal)
        data.append('company', firma)

        Api().post(`/upsellingFreischaltenEmail`, data).then(res => {
            setLoading(false)
            toast.success('Email wurde erfolgreich versendet.')
        }).catch(e => {
            setLoading(false)
            toast.error('Etwas ist schief gelaufen!')
        })
    };

    useEffect(() => {
        setLoading(true)

        Api().get(`sp_getUpsellingOptions/${'dgg'}`)
            .then(res => {
                setLoading(false)
                setUpsellingOptions(res.data)
            })
    }, [milestone]);

    return (<div>
            {loading ? <div hidden={next} style={{height: '32vh'}} className='mt-24'>
                <h2 className='text-center text-sm'>
                    Bitte haben Sie einen Moment Geduld, die Daten werden geladen...
                </h2>
                <span className='centerItemsRelative mt-2'><ClipLoader size={50} color={'#b4b4b4'}/></span>
            </div> : <div hidden={loading}>
                <div className='flex justify-between flex-wrap'>
                    <h2 className='text-xl mb-2 text-center font-bold'>{title}</h2>
                    <div className='flex justify-center ml-auto gap-2 float-right'>
                        <button
                            onClick={() => {
                                setValue(data[data?.length - 1]?.stepName, new Date('1900-01-01'))
                                addObjectToArray({
                                    firma: firma,
                                    id: data[data?.length - 1]?.substepID,
                                    milestone: currentMilestone,
                                    type: 'date',
                                    value: '1900-01-01',
                                    user: user.ID,
                                })
                            }}
                            // className={`${Number(currentMilestone) !== lastIndex && !getValues(data[data?.length-1]?.stepName) ? '' : 'hideDiv'} ${role === 'Supervisor' || role === 'Controller' && 'hidden'} hover:bg-lightBlue ml-auto bg-mainBlue text-white cursor-pointer px-4 my-2 text-sm py-2  rounded-3xl`}
                            className={`${Number(currentMilestone) !== lastIndex ? '' : 'hideDiv'} ${(role === 'ManDGG' || role === 'ManRUV' || role === 'Controller') && 'hidden'} hover:bg-lightBlue ml-auto bg-mainBlue text-white cursor-pointer px-4 my-2 text-sm py-2  rounded-3xl`}
                        >
                            P-Schritt überspringen
                        </button>
                        <button
                            onClick={() => ref.current?.click()}
                            disabled={!isValid}
                            className={`${(role === 'ManDGG' || role === 'ManRUV' || role === 'Controller') && 'hidden'} hover:bg-lightBlue ml-auto bg-mainBlue text-white cursor-pointer px-4 my-2 text-sm py-2  rounded-3xl`}
                        >
                            {Loading ? 'speichere...' : 'Speichern'}
                        </button>
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}
                      className='grid grid-cols-1 gap-1 mt-6 rounded-lg'>
                    {data.map((val, index) => (val.fieldType === 'option' ? <section
                            key={index} className='tooltip grid grid-cols-2 gap-1 mt-0 rounded-lg'
                            onChange={() => getValues(val.stepName) ? addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'option',
                                value: getValues(val.stepName),
                                user: user.ID,
                            }) : addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'option',
                                value: null,
                                user: user.ID,
                            })}>
                            <Options
                                role={role}
                                key={index}
                                grid={grid}
                                getValues={getValues}
                                register={register}
                                currentMilestone={currentMilestone}
                                lastDoneIndex={lastDoneIndex}
                                val={val}
                                option={options}
                            />
                        </section> : val.fieldType === 'date' ? <section
                            key={index} className='tooltip grid grid-cols-2 gap-1 mt-0 rounded-lg'>
                            <label
                                className={`text-grey text-sm ${val.isFinalStep === '1' && 'text-red2'} label`}>{val.stepName}</label>
                            <Controller
                                control={control}
                                name={val.stepName}
                                render={({field}) => (<div>
                                        <div ref={datePickerRef}
                                             className="flex justify-between items-center border-none">
                                            <DatePicker
                                                closeOnScroll={true}
                                                locale="de"
                                                dateFormat="P"
                                                showYearDropdown
                                                placeholderText={`Datum eingeben`}
                                                onBlur={() => setIsDatePickerOpen(false)}
                                                onChange={(date) => {
                                                    const converted = convertLocalToUTCDate(date);
                                                    field.onChange(converted);

                                                    addObjectToArray({
                                                        firma: firma,
                                                        id: val.substepID,
                                                        milestone: currentMilestone,
                                                        type: 'date',
                                                        value: converted,
                                                        user: user.ID,
                                                    });
                                                }}
                                                selected={field.value}
                                                isClearable
                                                className={`rounded-md border-2
                                                                     ${val.responsible?.toLowerCase() === 'aussendienst' ? 'border-borderBlue' : val.responsible?.toLowerCase() === 'innendienst' ? 'border-borderRed' : 'border-none'}
                                                                     `}
                                                open={isDatePickerOpen[index]}
                                                readOnly={(role === 'ManRUV' || role === 'ManDGG')}
                                            />
                                            <div
                                                className={`absolute ${getValues(val.stepName) && 'mr-6'} right-1.5`}
                                                style={{pointerEvents: 'none'}}>
                                                <GoCalendar color={'#4d57a8'} size={'18px'}
                                                            onClick={() => setIsDatePickerOpen((prevState) => ({
                                                                ...prevState, [index]: !prevState[index],
                                                            }))}
                                                />
                                            </div>
                                        </div>
                                    </div>)}
                            />
                            <p className={`${val.mouseoverText && 'tooltiptextclose'} `}>{val.mouseoverText}</p>
                        </section> : val.fieldType === 'header' ? <section key={index} className='tooltip flex'>
                            <label style={{fontSize: '.9rem'}}
                                   className={`py-2 text-text w-full font-bold text-left`}>
                                {val.stepName}
                            </label>
                        </section> : val.fieldType === 'text' ? <section
                            onChange={() => getValues(val.substepID) ? addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'text',
                                value: getValues(val.substepID),
                                user: user.ID,
                            }) : addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'text',
                                value: null,
                                user: user.ID,
                            })}
                            key={index}
                            className='tooltip flex grid grid-cols-2 gap-1 mt-0 rounded-lg'
                        >
                            <label className='text-sm text-grey label'>{val.stepName}</label>
                            <input placeholder='Text/Wert eingeben'
                                   disabled={(role === 'ManDGG' || role === 'ManRUV')}
                                   className={`subStepInput w-full p-2 md:w-full
                                                       ${Number(currentMilestone) < Number(lastDoneIndex) + 1 ? 'completed' : 'bg-white'}`}
                                   {...register(`${val.substepID}`)}
                                   type="text"
                                   style={{border: errors.email && '1px solid red'}}
                            />
                            {errors.email && touchedFields && <p>{errors.email.message}</p>}
                            <p className={`${val.mouseoverText && 'tooltiptextclose'} `}>{val.mouseoverText}</p>
                        </section> : val.fieldType === 'datero' ? <section
                            onChange={() => getValues(val.substepID) ? addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'datero',
                                value: getValues(val.substepID),
                                user: user.ID,
                            }) : addObjectToArray({
                                firma: firma,
                                id: val.substepID,
                                milestone: currentMilestone,
                                type: 'datero',
                                value: null,
                                user: user.ID,
                            })}
                            key={index}
                            className='tooltip flex grid grid-cols-2 gap-1 mt-0 rounded-lg'
                        >
                            <label className='text-sm text-grey label'>{val.stepName}</label>
                            <input placeholder='Text/Wert eingeben'
                                   disabled={(role === 'ManDGG' || role === 'ManRUV')}
                                   className={`subStepInput w-full p-2 md:w-full
                                                       ${Number(currentMilestone) < Number(lastDoneIndex) + 1 ? 'completed' : 'bg-white'}`}
                                   {...register(`${val.substepID}`)}
                                   type="text"
                                   style={{border: errors.email && '1px solid red'}}
                            />
                            {errors.email && touchedFields && <p>{errors.email.message}</p>}
                            <p className={`${val.mouseoverText && 'tooltiptextclose'} `}>{val.mouseoverText}</p>
                        </section> : <section
                            key={index}
                            className='tooltip flex grid grid-cols-2 gap-1 mt-0 rounded-md'>
                            <label className='text-sm text-grey label'>{val.stepName}</label>
                            <input disabled
                                   className={`w-full bg-white text-text border border-2 rounded-md
                                                                ${val.responsible?.toLowerCase() === 'aussendienst' ? 'border-borderBlue' : val.responsible?.toLowerCase() === 'innendienst' ? 'border-borderRed' : 'border-none'}
                                                             `}
                                   {...register(`${val.substepID}`)}
                                   value={getValues(val.stepName)}
                                // value={'Read Only'}
                            />
                            <p className={`${val.mouseoverText && 'tooltiptextclose'} `}>{val.mouseoverText}</p>
                        </section>))}
                    {((milestone === '8' && portal === 'dgg') || (milestone === '11' && portal === 'ruv')) && (<div className="mt-6">
                            <div className="flex justify-between items-center mb-3">
                                <div className="flex items-center gap-4">
                                    <button
                                        type="button"
                                        onClick={() => dispatch({ type: "SET_BERATERTAGE_MODAL_OPEN", item: true })}
                                        className="hover:bg-lightBlue bg-mainBlue text-white cursor-pointer px-4 py-2 text-sm rounded-3xl"
                                    >Beratertage Planung</button>
                                    <span className="text-sm text-gray-600">
                                        {erfBeratTage > 0
                                            ? `Beratertage Planung - Erforderlich sind ca. ${erfBeratTage} Beratungs-Tage`
                                            : "Beratertage Planung - noch ausstehend"
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>)}
                    {(((milestone === '2' || milestone === '4' || milestone === '6') && portal === 'dgg')) && (<div className="mt-6">
                            <div className="flex justify-between items-center mb-3">
                                <div className="flex items-center gap-4">
                                    <button
                                        type="button"
                                        onClick={() => setEditStates()}
                                        className="hover:bg-lightBlue bg-mainBlue text-white cursor-pointer px-4 py-2 text-sm rounded-3xl"
                                    >Dienstleistungen</button>
                                    <CompanyUpsellingBadge
                                        portal={portal}
                                        showUpselling={true}
                                        companyID={firma}
                                        hasUpselling={hasUpselling}
                                        dataUpselling={dataUpselling}
                                    />
                                </div>
                            </div>
                        </div>)}
                    <input ref={ref} hidden type="submit"/>
                </form>
            </div>}
            {beratertageModalOpen && (
                <BeratertageModal
                    portal={portal}
                    firma={firma}
                    onValueChange={(newValue) => setErfBeratTage(newValue)}
                />
            )}
        {dienstleistungenModalOpen && (
            <DienstleistungenModal
                data={dataUpselling}
                handleClick={handleClick}
                setEditStates={setEditStates}
                upsellingOptions={upsellingOptions}
                firma={firma}
                onClose={() => setDienstleistungenModalOpen(false)}
            />
        )}
        </div>)
}
export default SubSteps
